"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entitySummaryField = exports.entityContentField = exports.entityDescriptionField = exports.entityLongTextField = void 0;
var react_1 = __importDefault(require("react"));
var sprintf_js_1 = require("sprintf-js");
var input_markdown_editor_1 = require("../components/forms/input-markdown-editor");
var entity_field_1 = require("./entity-field");
var entityLongTextField = function (args) {
  var name = args.name,
    placeholder = args.placeholder,
    label = args.label,
    description = args.description,
    context = args.context,
    focus = args.focus,
    _a = args.height,
    height = _a === void 0 ? '80px' : _a,
    _b = args.fieldSet,
    fieldSet = _b === void 0 ? 'overview' : _b,
    required = args.required,
    isAvailable = args.isAvailable;
  var t = context.t,
    definition = context.definition,
    fieldState = context.fieldState,
    entityTypeName = context.entityTypeName;
  return __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    height: height,
    render: function (props) {
      return react_1.default.createElement(input_markdown_editor_1.InputMarkdownEditor, __assign({}, props, {
        entityName: fieldState.name && fieldState.name.value,
        entityTypeName: entityTypeName
      }));
    }
  });
};
exports.entityLongTextField = entityLongTextField;
var entityDescriptionField = function (args) {
  var context = args.context;
  var t = context.t,
    definition = context.definition;
  var description = args.description === undefined ? (0, sprintf_js_1.sprintf)(t('Provide a description of this %s for listing and detail views.'), definition.label) : args.description;
  var label = args.label === undefined ? 'Description' : args.label;
  var height = args.height || '160px';
  var name = args.name || 'description';
  return (0, exports.entityLongTextField)(__assign(__assign({}, args), {
    name: name,
    description: description,
    height: height,
    label: label
  }));
};
exports.entityDescriptionField = entityDescriptionField;
var entityContentField = function (args) {
  var context = args.context;
  var t = context.t,
    definition = context.definition;
  var description = args.description === undefined ? (0, sprintf_js_1.sprintf)(t('Provide the main content for this %s.'), definition.label) : args.description;
  var label = args.label === undefined ? 'Content' : args.label;
  var height = args.height || '40vh';
  var name = args.name || 'content';
  return (0, exports.entityLongTextField)(__assign(__assign({}, args), {
    name: name,
    description: description,
    height: height,
    label: label
  }));
};
exports.entityContentField = entityContentField;
var entitySummaryField = function (args) {
  var context = args.context;
  var t = context.t,
    definition = context.definition;
  var description = args.description || (0, sprintf_js_1.sprintf)(t('Provide a summary of this %s for listing views, as an alternative to auto-shortening the description.'), definition.label);
  var label = args.label || 'Summary';
  var name = args.name || 'summary';
  var height = args.height || '80px';
  return (0, exports.entityLongTextField)(__assign(__assign({}, args), {
    name: name,
    height: height,
    description: description,
    label: label
  }));
};
exports.entitySummaryField = entitySummaryField;